// La Motora - Custom JS
(function ($) {
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('#main-nav').addClass('navbar-scrolled');
        } else {
            $('#main-nav').removeClass('navbar-scrolled');
        }
    });

    // Load more modelos
    $('#load-more-modelos').on('click', function (e) {
        e.preventDefault();

        var button = $(this);
        var page = button.data('page');
        var maxPages = button.data('max');
        var newPage = page + 1;
        var spinner = $('#load-more-spinner');

        button.addClass('disabled').prop('disabled', true);
        spinner.removeClass('d-none');

        $.ajax({
            url: lamotora_ajax.ajax_url,
            type: 'POST',
            data: {
                action: 'load_more_modelos',
                page: newPage
            },
            success: function (response) {
                if (response) {
                    $('#modelos-grid-container').append(response);
                    button.data('page', newPage);
                    button.removeClass('disabled').prop('disabled', false);

                    if (newPage >= maxPages) {
                        button.removeClass('d-inline-block').addClass('d-none');
                    }
                } else {
                    button.removeClass('d-inline-block').addClass('d-none');
                }
            },
            error: function () {
                console.error("Error cargando más modelos.");
                button.removeClass('disabled').prop('disabled', false);
            },
            complete: function () {
                spinner.addClass('d-none');
            }
        });
    });
})(jQuery);